import { useStore } from "@/stores";

export const useCurrentLocale = () => {
  const { uiStore } = useStore();
  return uiStore.locale;
};
